// frontend/src/pages/BlockchainExplorer.jsx
import React from "react";
import { useQuery } from "@apollo/client";
import { GET_BLOCKCHAIN_STATS } from "../graphql/queries/getBlockchainStats";
import BlockchainStatusCard from "../components/BlockchainStatusCard";

export default function BlockchainExplorer() {
  const { data, loading, error } = useQuery(GET_BLOCKCHAIN_STATS, {
    pollInterval: 5000, // rafraîchit toutes les 5s
  });

  if (loading) return <p className="text-gray-400">Chargement...</p>;
  if (error) return <p className="text-red-500">Erreur : {error.message}</p>;

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4 text-white">🔍 Blockchain Explorer</h1>
      <BlockchainStatusCard stats={data.blockchainStats} />
    </div>
  );
}
